import React from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet } from 'lucide-react';
export function Solution() {
  return <section className="py-20 bg-[#fafaf9] border-t border-stone-100" data-id="element-142">
      <div className="container mx-auto px-4 md:px-6" data-id="element-143">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1" data-id="element-145">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-sm border border-stone-100 mb-6" data-id="element-146">
              <FileSpreadsheet className="w-5 h-5 text-[#10b981]" data-id="element-147" />
              <span className="text-sm font-medium text-stone-600" data-id="element-148">
                Google Sheets Template
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-149">
              Un sistema simple para ordenar tus finanzas personales
            </h2>
            <div className="space-y-4 text-lg text-stone-600" data-id="element-150">
              <p data-id="element-151">
                Esta plantilla no es para contadores ni expertos en Excel. Está
                diseñada para
                <span className="font-semibold text-stone-800" data-id="element-152">
                  {' '}
                  personas reales
                </span>{' '}
                con gastos y deudas reales.
              </p>
              <p data-id="element-153">
                Olvidate de fórmulas complejas o software difícil de entender.
                Acá solo ingresás tus datos y automáticamente obtenés la
                claridad que necesitás para tomar el control.
              </p>
              <p data-id="element-154">
                Es el puente entre el caos financiero y la tranquilidad mental
                de saber exactamente dónde estás parado.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full" data-id="element-155">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-156">
              <img src="https://cdn.magicpatterns.com/uploads/8aoCh1qXxmcHXSddtDkMQT/Diseno_sin_titulo_(7).png" alt="Plantilla de Finanzas Personales en Google Sheets" className="w-full h-auto" data-id="element-157" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}